import { motion } from "framer-motion";
import { ArrowRight, Images } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useQuote } from "@/context/QuoteContext";
import { PROJECTS } from "@/data/site";

export const Projects = () => {
  const { openQuote } = useQuote();

  return (
    <section id="projects" data-testid="projects-section" className="py-16 sm:py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-sm uppercase tracking-[0.2em] font-bold text-red-700">Real Work, Real Results</span>
            <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-950">
              Recent Projects From Our Crews
            </h2>
            <p className="mt-4 text-lg text-slate-600 leading-relaxed">
              Actual roofing and construction projects completed by Templar Armor across California.
              Every one personally verified by the owner.
            </p>
          </div>
          <Button
            data-testid="projects-quote-btn"
            onClick={() => openQuote()}
            className="shrink-0 bg-red-700 hover:bg-red-800 text-white font-bold rounded-full h-12 px-7 hover:scale-105 transition-transform"
          >
            Get a Quote Like This <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
          {PROJECTS.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: (i % 4) * 0.08 }}
              data-testid={`project-${i}`}
              className={`group relative overflow-hidden rounded-2xl border border-slate-200 shadow-sm ${
                i === 0 || i === 5 ? "lg:row-span-2" : ""
              }`}
            >
              <img
                src={p.src}
                alt={p.label}
                loading="lazy"
                className={`w-full object-cover transition-transform duration-500 group-hover:scale-110 ${
                  i === 0 || i === 5 ? "h-64 lg:h-full" : "h-44 lg:h-56"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-slate-950/10 to-transparent opacity-90" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="inline-block text-[10px] font-bold uppercase tracking-wider text-white bg-red-700 rounded-full px-2.5 py-1 mb-1.5">
                  {p.tag}
                </span>
                <p className="text-white font-display font-semibold text-sm leading-tight">{p.label}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-8 flex items-center justify-center gap-2 text-slate-500 text-sm font-medium">
          <Images className="h-4 w-4" /> Photos from completed Templar Armor projects
        </div>
      </div>
    </section>
  );
};
